import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { submitForm } from "../../Helpers/API/formsAPI";
import { getRegionConfig } from "./config/regionConfig";

function FlagshipFeedback({ navigation, primaryDetails, setPrimaryDetails }) {
  const navigate = useNavigate();
  const [isError, setIsError] = useState({
    is_flagship_satisfied: false,
    flagship_feedback: false,
    flagship_option_prize: false,
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Sync to primaryDetails whenever state changes
  useEffect(() => {
    setPrimaryDetails((prev) => ({
      ...prev,
    }));
  }, [setPrimaryDetails]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: files ? files[0] : value,
    }));

    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      is_flagship_satisfied: !primaryDetails.is_flagship_satisfied,
      flagship_feedback: !primaryDetails.flagship_feedback,
      flagship_option_prize: !primaryDetails.flagship_option_prize,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some((error) => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields.", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.is_flagship_satisfied &&
      !!primaryDetails.flagship_feedback &&
      !!primaryDetails.flagship_option_prize;
  };
  const handleNext = () => {
    if (validateForm()) {
      setShowConfirmModal(true);
    }
  };

  const handleConfirmSubmit = async () => {
    setIsSubmitting(true);

    try {
      const regionConfig = getRegionConfig(primaryDetails?.region);
      const res = await submitForm(primaryDetails, regionConfig);
      if (res?.data) {
        const extractId = (payload) => {
          if (!payload) return null;
          if (payload.id) return payload.id;
          if (payload.form_id) return payload.form_id;
          if (payload.test_id) return payload.test_id;
          if (payload.record_id) return payload.record_id;
          if (payload.data) {
            const d = payload.data;
            if (d?.id) return d.id;
            if (d?.form_id) return d.form_id;
            if (d?.test_id) return d.test_id;
            if (d?.record_id) return d.record_id;
          }
          return null;
        };
        const newId = extractId(res.data);
        if (newId && !primaryDetails.id) {
          setPrimaryDetails && setPrimaryDetails(prev => ({ ...prev, id: newId, _partial_saved: true }));
        } else if ((primaryDetails.id) && !primaryDetails._partial_saved) {
          setPrimaryDetails && setPrimaryDetails(prev => ({ ...prev, _partial_saved: true }));
        }
        localStorage.setItem('form_completed', 'true');
        setShowConfirmModal(false);
        if (navigation && navigation.go) {
          navigate('/timein', { replace: true });
        }
      } else {
        toast.error("Submit failed. Please try again.", { autoClose: 2500, hideProgressBar: true, theme: "colored" });
      }
    } catch (err) {
      toast.error("Something went wrong while submitting.", { autoClose: 2500, hideProgressBar: true, theme: "colored" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelSubmit = () => {
    setShowConfirmModal(false);
  };

  const handleBack = () => {
    if (navigation && navigation.previous) {
      navigation.previous();
    }
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Flagship Feedback</h4>
              <p className="form-desc">Please provide feedback on the flagship awarding</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>

                  {/* Is merchant satisfied with his/her merienda or Maya Credits? */}
                  <Form.Group className="mb-4" controlId="is_flagship_satisfied">
                    <Form.Label className="form-label">
                      Is Merchant Satisfied with His/Her Merienda or Maya Credits? <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="is_flagship_satisfied"
                      value={primaryDetails.is_flagship_satisfied || ""}
                      onChange={handleInputChange}
                      className={`form-input ${isError.is_flagship_satisfied ? "error" : ""}`}
                    >
                      <option value="">Select an option</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Form.Select>
                    {isError.is_flagship_satisfied && (
                      <div className="form-error">Please select an option.</div>
                    )}
                  </Form.Group>

                  {/* Verbatim Feedback */}
                  <Form.Group className="mb-4" controlId="flagship_feedback">
                    <Form.Label className="form-label">
                      Verbatim Feedback <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="flagship_feedback"
                      value={primaryDetails.flagship_feedback || ""}
                      onChange={handleInputChange}
                      placeholder="Enter feedback"
                      className={`form-input ${isError.flagship_feedback ? "error" : ""}`}
                    />
                    {isError.flagship_feedback && (
                      <div className="form-error">Please enter feedback.</div>
                    )}
                  </Form.Group>

                  {/* If ever na may ibang options na prize, ano ang gusto ni merchant? */}
                  <Form.Group className="mb-4" controlId="flagship_option_prize">
                    <Form.Label className="form-label">
                      If Ever May Ibang Options na Prize, Ano ang Gusto ni Merchant? <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="flagship_option_prize"
                      value={primaryDetails.flagship_option_prize || ""}
                      onChange={handleInputChange}
                      placeholder="Enter preferred prize option"
                      className={`form-input ${isError.flagship_option_prize ? "error" : ""}`}
                    />
                    {isError.flagship_option_prize && (
                      <div className="form-error">Please enter preferred prize option.</div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Submit
                    </AppButton>
                  </div>

                </Form>
              </div>
            </div>
          </Col>
        </Row>

        {/* Confirmation Modal */}
        <Modal show={showConfirmModal} onHide={handleCancelSubmit} centered>
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="w-100 text-center fw-bold text-primary">
              ⚠️ Confirm Submission
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center py-4">
            <div className="mb-3">
              <i className="fas fa-exclamation-triangle text-warning" style={{fontSize: '3rem'}}></i>
            </div>
            <h5 className="mb-3 text-dark">Are you sure you want to proceed?</h5>
            <p className="text-muted mb-0">
              <strong>Once submitted, you can't go back to make changes.</strong>
            </p>
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center pt-0">
            <Button 
              variant="outline-secondary" 
              onClick={handleCancelSubmit}
              className="px-4 me-3"
              style={{minWidth: '100px'}}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button 
              variant="primary" 
              onClick={handleConfirmSubmit}
              className="px-4"
              style={{minWidth: '100px', backgroundColor: '#007bff'}}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Submitting...
                </>
              ) : (
                'Yes, Proceed'
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}

export default FlagshipFeedback;
